import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "next",
  "use": "next-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"next\"><path fill-rule=\"evenodd\" d=\"M14.885 10 8 15.594V17l9-7.5L8 2v1.406L14.885 9H2v1h12.885Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol